import React, { useState } from 'react';
import { bool, string, func } from 'prop-types';
import TasksListItemView from '../../components/tasks-list-item-view/tasks-list-item-view';

const TasksListItem = ({
  label, important, completed, onEdit, onToggleImportant, onToggleCompleted, getDeleteTaskId, onToggleShowModal
}) => {
  const [edit, setEdit] = useState(false)
  const [editedValue, setEditedValue] = useState('')

  const toggleEdit = () => setEdit(prevState => !prevState)
  const onChangeEditedValue = value => setEditedValue(value)

  const onSubmitEditedTask = ({ key, target: { value } }) => {
    if (key === 'Escape') {
      setEdit(prevState => !prevState)
    }
    if (key === 'Enter' && value.trim()) {
      onEdit(editedValue)
      setEdit(prevState => !prevState)
    }
  }

  const handleModal = () => {
    onToggleShowModal()
    getDeleteTaskId()
  }

  const onChangeEditedTask = ({ target: { value } }) => {
    if (!value) {
      onChangeEditedValue('Введите текст задачи')
    } else {
      onChangeEditedValue(value)
    }
  }

  return (
    <>
      <TasksListItemView
        edit={edit}
        onChangeEditedTask={onChangeEditedTask}
        onSubmitEditedTask={onSubmitEditedTask}
        editedValue={editedValue}
        toggleEdit={toggleEdit}
        handleModal={handleModal}
        important={important}
        completed={completed}
        label={label}
        onToggleImportant={onToggleImportant}
        onToggleCompleted={onToggleCompleted}
      />
    </>
  )
}

TasksListItem.propTypes = {
  onEdit: func,
  onToggleShowModal: func,
  onToggleCompleted: func,
  onToggleImportant: func,
  getDeleteTaskId: func,
  label: string,
  important: bool,
  completed: bool,
}

TasksListItem.defaultProps = {
  onEdit: () => { },
  onToggleCompleted: () => { },
  onToggleShowModal: () => { },
  onToggleImportant: () => { },
  getDeleteTaskId: () => { },
  label: '',
  important: false,
  completed: false,
}

export default TasksListItem